import React, { useState , useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar'
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { connect, useDispatch, useSelector} from 'react-redux';

import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  TextField,
} from '@material-ui/core';
import Page from 'src/components/Page';
import { alertActions, userActions } from '../../_actions';
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width:1000,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  form: {
    display: 'flex',
    justifyContent: 'center',
  }
}));




const ChangePassword = () => {
  const [submitted, setSubmitted] = useState(false);
  const registering = useSelector(state => state.registration.isregitered);
  const dispatch = useDispatch();
  useEffect(() => { 
    dispatch(alertActions.clear()); 
  }, []);
  const classes = useStyles();  
  return (
    
    <React.Fragment>
      <CssBaseline />
      <AppBar position="absolute" color="default" className={classes.appBar}>       
      </AppBar>
      <main className={classes.layout}>
      <Paper className={classes.paper}> 
    
          <Formik
           className={classes.form}
            initialValues={{
              oldPassword: '',
              newPassword: '',
              confirmPassword: '',                   
              
              
            }}
            validationSchema={
              Yup.object().shape({
                oldPassword: Yup.string().max(255).required('La contraseña actual es requerida'),     
                newPassword: Yup.string().max(255).required('La nueva contraseña  es requerida')
                /*.matches(
                  "^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{8,}$",
                  "Debe contener 8 caracteres, un número y un carácter en mayúsculas y minúsculas"
                )*/,
                confirmPassword: Yup.string().max(255).required('Debe confirmar la contraseña').oneOf([Yup.ref("newPassword"), null],"Las contraseñas no coinciden")                
              })
            }
            onSubmit={(values,actions) => {
              setSubmitted(true);
              dispatch(userActions.changePassword(values.oldPassword,values.newPassword));            
              
              
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={3}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                  >
                   Cambiar Contraseña
                  </Typography>
                 
                </Box>
                <Grid item xs={5} sm={7}> 
                <TextField
                  error={Boolean(touched.oldPassword && errors.oldPassword)}
                  fullWidth
                  helperText={touched.oldPassword && errors.oldPassword}
                  label="Contraseña Actual"
                  margin="normal"
                  name="oldPassword"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.oldPassword}
                  variant="outlined"                  
                />
                </Grid>
                <Grid item xs={5} sm={7}> 
                <TextField
                  error={Boolean(touched.newPassword && errors.newPassword)}
                  fullWidth
                  helperText={touched.newPassword && errors.newPassword}
                  label="Nueva Contraseña"
                  margin="normal"
                  name="newPassword"
                  type="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.newPassword}
                  variant="outlined"
                />
                </Grid>
                <Grid item xs={5} sm={7}> 
                <TextField
                  error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                  fullWidth
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  label="Confirmar Contraseña"
                  margin="normal"
                  name="confirmPassword"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.confirmPassword}
                  variant="outlined"
                />             
                </Grid>
                <Grid item xs={5} sm={7}> 
                <Box my={2} >
                  <Button
                    color="primary"
                    disabled={submitted}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                   Aceptar
                  </Button>
                </Box> 
                </Grid>              
              </form>
            )}
          </Formik>
     
      </Paper>  
      </main>          
    </React.Fragment>    
  );
}

export default  ChangePassword;